<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { APP_STORAGE_URL } from './js/config';
export default {
  name: 'app',
  methods: {
    webPNMessage(){
      if(this.$messaging){
        console.log('initialiiting Messagiong');
        this.$messaging.onMessage(payload=>{
          if(payload.data.data){
            let $data=JSON.parse(payload.data.data);
            console.log($data);
            const notificationTitle = payload.data.title;
            const notificationOptions = {
                body: payload.data.body,
                icon: "./logo.png",
            };
            const notification = new Notification(notificationTitle, notificationOptions);
            notification.onclick=()=>{
              window.open(APP_STORAGE_URL+$data.url);
            }
          }else{
            // Customize notification here
            const notificationTitle = payload.data.title;
            const notificationOptions = {
                body: payload.data.body,
                icon: "./logo.png",
            };
            new Notification(notificationTitle, notificationOptions)
          }
        })
      } 
    }
  },
  mounted: function(){
    this.webPNMessage();
  }
}
</script>


<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');

#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  text-align: left;
  color: #2c3e50;
  font-size: 0.9rem;
}
</style>
